/* 3P quote tracking (29 Sep 2026).
   The cart drawer injects the quote form with innerHTML, where inline
   scripts never run, so the tracking lives here and listens on the
   document. Pushes `quote_requested` to the dataLayer once per valid send
   with the cart value, for the GTM conversion tag and GA4 key event.
   Also submits the form on Enter, and adds a spam and junk folder note
   under the confirmation (1 Oct 2026). */
(function () {
  if (window.__tp3qBound) return;
  window.__tp3qBound = true;

  function valid(wrap) {
    var required = wrap.querySelectorAll('[required]');
    for (var i = 0; i < required.length; i++) {
      if (!required[i].value) return false;
    }
    var email = wrap.querySelector('#cartEmail');
    if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) return false;
    return true;
  }

  function push(wrap) {
    var funding = wrap.querySelector('#tp3q-funding');
    var source = (wrap.id || 'quote-cart').replace(/^quote-/, '');
    var base = {
      event: 'quote_requested',
      quote_source: source,
      funding_type: funding ? funding.value : ''
    };
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign(base, {
          value: (cart.total_price || 0) / 100,
          currency: cart.currency || 'AUD',
          items: cart.item_count || 0
        }));
        document.dispatchEvent(new CustomEvent('avail:quote-requested', { detail: base }));
      })
      .catch(function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(base);
      });
  }

  /* EasyQuote writes its confirmation into #easyquote-status. The quote email
     goes out from the app's shared sending address and some inboxes file it
     as junk (Dave, 1 Oct 2026), so a line goes under the confirmation once it
     appears. Watches for up to 20 seconds after a valid send. */
  var JUNK_NOTE = 'Not in your inbox within a few minutes? Check your spam or junk folder, or call us on 1300 945 720.';

  function noteJunk(wrap) {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var status = wrap.querySelector('#easyquote-status');
      if (status && /thank|shortly|sent/i.test(status.textContent)) {
        if (!wrap.querySelector('.tp3q-junk')) {
          var note = document.createElement('p');
          note.className = 'tp3q-fine tp3q-junk';
          note.textContent = JUNK_NOTE;
          status.insertAdjacentElement('afterend', note);
        }
        clearInterval(timer);
      } else if (tries > 66) {
        clearInterval(timer);
      }
    }, 300);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.tp3q #create-quote');
    if (!btn) return;
    var wrap = btn.closest('.tp3q');
    if (!wrap || !valid(wrap)) return;
    if (wrap.dataset.tp3qSent) return;
    wrap.dataset.tp3qSent = '1';
    setTimeout(function () { delete wrap.dataset.tp3qSent; }, 15000);
    push(wrap);
    noteJunk(wrap);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var wrap = e.target.closest && e.target.closest('.tp3q');
    if (!wrap || e.target.tagName === 'SELECT') return;
    var btn = wrap.querySelector('#create-quote');
    if (btn) { e.preventDefault(); btn.click(); }
  });
})();
